import {
    Backdrop,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    CircularProgress,
    Divider,
    GridList,
    GridListTile,
    GridListTileBar,
    IconButton,
    Modal,
    Dialog,
    TextField,
    FormControlLabel,
    RadioGroup,
    Radio,
    Grid,
    Checkbox
  } from '@material-ui/core';
  import { makeStyles } from '@material-ui/styles';
  import clsx from 'clsx';
  import React, { useEffect, useState } from 'react';
  import { useTranslation } from 'react-i18next';
  import axios from 'src/utils/axios';
  import { useDispatch, useSelector } from 'react-redux';
  import Save from '@material-ui/icons/Save';
import { red } from '@material-ui/core/colors';

  
  const useStyles = makeStyles(theme => ({
    rootSurveyDetails: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      outline: 'none',
      boxShadow: theme.shadows[20],
      width: 700,
      maxHeight: '100%',
      overflowY: 'auto',
      maxWidth: '100%'
    },
    actionsPopup: {
      justifyContent: 'flex-end'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    surveyDescription:{
        fontSize:'14px'
    },
    content:{
        fontSize:'14px'
    },
    answerDescription:{
        fontWeight:'bold'
    },
    notAcceptCheckbox: {
      flexGrow:1,
      color:red[500],
      marginRight:'3px'
    },
    surveyDeclineContainer:{
      display:'flex',
      backgroundColor:'#f5f5f5'
    }

  }));
  
  function TechnicianSurveyDetails({ open, onClose, survey, surveyQuestionAnswers,workOrderId, className,reloadSurveysList,handleSurveyClickReload }) {
    const classes = useStyles();
    const { t } = useTranslation('common');
    const locale = localStorage.getItem('i18nextLng');
    const [uyariTip, setUyariTip] = React.useState('error');
    const [uyari, setUyari] = useState(false);
    const dispatch = useDispatch();
  
    const [surveyReadyToComplete, setsurveyReadyToComplete] = React.useState(false);
    const [data, setData] = useState({});
    const [isSurveyCompleted,setIsSurveyCompleted] = React.useState()
    const [isCustomerNotAcceptedSurvey,setisCustomerNotAcceptedSurvey] = React.useState(null);

    const handleCompleteSurvey = ()=>{

        setsurveyReadyToComplete(false);
        axios
        .post(
            `/SaveUpdateSurveyAnswers/${survey.Id}/${workOrderId}`,JSON.stringify(data),{
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        )
        .then(response => {
          if (response.data == null || response.data.StatusCode != 200) {
            console.error("An error occured while fetching survey questions/answers. Please check error logs.");
          } 
          else {
           onClose(survey.Id);
           setIsSurveyCompleted(true)
           setsurveyReadyToComplete(true);
           reloadSurveysList();
          }
    })
    .catch(error => {
      console.error(error);
  
    });
    }

    const updateSurveyCompletionStatus = (surveyId,workorderId,status) => {
      axios
        .get(
          `/UpdateSurveyCompletionStatus/${surveyId}/${workorderId}/${status}`
        )
        .then(response => {
          if (response.data == null || response.data.StatusCode != 200) {
            console.error("An error occured while fetching survey questions/answers. Please check error logs.");
          } 
          else {
            handleSurveyClickReload(null,survey);
            
          }
    })
    .catch(error => {
      console.error(error);
  
    });
  }


    useEffect(() => {
        
        if(survey != null ){
            var totalNeedAnswerQuestionsCount = surveyQuestionAnswers.SiriusQuestionsWithAnswerOptions.length;
            var answeredQuestionLength = Object.keys(data).length;
            if(answeredQuestionLength >= totalNeedAnswerQuestionsCount){
                setsurveyReadyToComplete(true);
            }
            else{
                setsurveyReadyToComplete(false);
            }
        }

      }, [data]);

    const onInputChange = async e => {
        const {name, value} = e.target;
        //check to validate if entry is not a number
        if(isNaN(name)){
          data[name] = value;
          
          //somehow update data
          setData({...data})
        }
      }

      const handleSurveyNotAccepted = (event)=>{
        var checked = event.target.checked;
        setisCustomerNotAcceptedSurvey(checked);

        updateSurveyCompletionStatus(survey.Id,workOrderId,checked);
      }
    
    function RenderQAComponents(surveyQa) {
        switch(surveyQa.AnswerType) {
          case 'freetext':
            return (
                <div>
                {surveyQa.SiriusAnswerOptions.map((option,index) => (
                <TextField
                    id="standard-full-width"
                    fullWidth
                    margin="normal"
                    name={surveyQa.AnswerType+"_"+surveyQa.Id+"_"+option.Id}
                    onBlur={onInputChange}
                    value={data[surveyQa.AnswerType+"_"+surveyQa.Id]}
                />
            ))}</div>
            )
          case 'singleselect':
            return (
            <div>
                <RadioGroup name={surveyQa.AnswerType+"_"+surveyQa.Id} value={data[surveyQa.AnswerType+"_"+surveyQa.Id]} onChange={onInputChange}>
                {surveyQa.SiriusAnswerOptions.map((option,index) => (
                    <FormControlLabel 
                        checked={data[surveyQa.AnswerType+"_"+surveyQa.Id]==option.Id?true:false}
                    key={option.Id} value={option.Id} control={<Radio />} label={option.Text} />
                ))}
                </RadioGroup>
            </div>
            )
          case 'multiselect':
            return (
                <div>
                {surveyQa.SiriusAnswerOptions.map((option,index) => (
                     <FormControlLabel
                     control={<Checkbox  checked={data[surveyQa.AnswerType+"_"+surveyQa.Id+"_"+option.Id]==option.Id?true:false} onChange={onInputChange} 
                     name={surveyQa.AnswerType+"_"+surveyQa.Id+"_"+option.Id} value={option.Id} />}
                     label={option.Text}
                   />
                ))}
            </div>
            )
          default:
            return (
                <div>
                    Component Error Getting
                </div>
            )
        }
      }

      function RenderAnswers(surveyQa) {
        switch(surveyQa.AnswerType) {
          case 'freetext':
            return (
                <div>
                {surveyQa.SiriusSurveyResponses.map((value,index) => (
                <span key={surveyQa.AnswerType+"_"+index}>{value.SiriusAnswer.Text}</span>
            ))}</div>
            )
          case 'singleselect':
            return (
            <div>
                {surveyQa.SiriusSurveyResponses.map((option,index) => (
                     <div>
                     {option.SiriusAnswer.Text}
                     </div>
                ))}
            </div>
            )
          case 'multiselect':
            return (
                <div>
                 {surveyQa.SiriusSurveyResponses.map((option,index) => (
                     <div>
                                          {option.SiriusAnswer.Text}

                     </div>
                ))}
            </div>
            )
          default:
            return (
                <div>
                    Component Error Getting
                </div>
            )
        }
      }

    if (!open) {
      return null;
    }

    return (
      <Modal
        onClose={() => {
          onClose();
        }}
        open={open}
      >
        <Card className={clsx(classes.rootSurveyDetails, className)}>
          <CardHeader title={survey.Title} subheader={survey.Description}  />
          {!survey.IsSurveyAcceptedToFillOut == true &&
            <div className={classes.surveyDeclineContainer}>
                    <FormControlLabel
                        className={classes.notAcceptCheckbox}
                        value={survey}
                        // checked={(survey.IsSurveyAcceptedToFillOut ==null || survey.IsSurveyAcceptedToFillOut == false)?false:true}
                        checked={(survey.IsSurveyAcceptedToFillOut == null || surveyReadyToComplete.IsSurveyAcceptedToFillOut == true)? false:true || isCustomerNotAcceptedSurvey == true?true:false}
                        onChange={handleSurveyNotAccepted}
                        control={<Checkbox color="secondary" />}
                        label="The customer has declined the survey"
                        labelPlacement="start"
                        disabled = {isCustomerNotAcceptedSurvey == null?survey.IsSurveyAcceptedToFillOut ==false?true:false:isCustomerNotAcceptedSurvey}
                    />
            </div>
          }

                    {!isCustomerNotAcceptedSurvey &&
                              <CardContent className={classes.content}>
                              {surveyQuestionAnswers.SiriusQuestionsWithAnswerOptions.map((surveyqa) => (
                    
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                    <div>
                                        <span className={classes.answerDescription}>{surveyqa.Description}</span>
                    
                                    </div>
                                        <div>
                    
                                        {!survey.IsCompleted &&
                                            RenderQAComponents(surveyqa)
                                        }
                                        {survey.IsCompleted &&
                                            RenderAnswers(surveyqa)
                                        }
                                    </div>
                                    </Grid>
                                </Grid>
                              ))}
                              </CardContent>
                    }

          <Divider />
          <CardActions className={classes.actionsPopup}>
          {!survey.IsCompleted &&
<div>

          <Button
          className={classes.surveyButtonsRight}
              variant="contained"
              color="secondary"
              onClick={() => {
                handleCompleteSurvey();
              }}
              startIcon={<Save />}
              disabled={surveyReadyToComplete == false?true:false}
            >
              {/* {t('Kapat')} */}
              Complete Survey
            </Button></div>
            }
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                onClose();
              }}
            >
              {t('Kapat')}
            </Button>
          </CardActions>
        </Card>
      </Modal>
      
    );
  }
  
  TechnicianSurveyDetails.defaultProps = {
    open: false,
    onClose: () => {}
  };
  
  export default TechnicianSurveyDetails;
  